__turbopack_context__.v({
  "content": "lzLCcq_content",
  "descriptionLines": "lzLCcq_descriptionLines",
  "emptyBanner": "lzLCcq_emptyBanner",
  "iconRow": "lzLCcq_iconRow",
  "item": "lzLCcq_item",
  "items": "lzLCcq_items",
  "section": "lzLCcq_section",
});
